import axios from "axios";
export class Bitquery {
  constructor() {
    this.http = axios.create({
      baseURL: "https://streaming.bitquery.io",
      maxBodyLength: Infinity,
      headers: {
        common: {
          Authorization: this.randomAuth(),
          "Content-Type": "application/json",
        },
      },
    });
  }

  randomAuth() {
    const arrAuth = [
      "Bearer ory_at_Zmib07MHSiJPwhxLnvhKt8ajvbHq-KUHixGxR9G16N4.Obp19uSdtjeWaSlHbGLIMZMUJaMC9DGQ4HO435bcsGM",
      "Bearer ory_at_j8kAox9jWqPowOuxgiqwNn9kN9KPG2_LzNcpFdZFrqU.YsGiC9r5heXKRWhFWXaxy6uVV80-IbOP-CnOoTufbdg",
      "Bearer ory_at_PwWbwLY5-KZT05k8xjE99jj9yIQ3DGBB2or9DfZrN4Y.s6B57ik40tYkZlQCR5L0mFma8bfowI68ttRytRrJLuU",
      "Bearer ory_at_hAgcbMhuld4lPgfvPviIjsLjgBDe5c6vX8kYKHbBqNc.psM3JoCQnISyk1GhkvJaEcfA9Ot-EC-Z3TqUjc05E-A",
    ];
    return arrAuth[Math.floor(Math.random() * arrAuth.length)];
  }

  getDate() {
    const today = new Date();

    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  async getTokenHolders(tokenAddress, minAmount = 0, network = "eth") {
    let data = JSON.stringify({
      query: `{
          EVM(dataset: archive, network: ${network}) {
            TokenHolders(
              date: "${this.getDate()}"
              tokenSmartContract: "${tokenAddress}"
              limit: {count: 80}
              orderBy: {descending: Balance_Amount}
              where: {Balance: {Amount: {ge: "${minAmount}"}}}
            ) {
              Holder {
                Address
              }
              Balance {
                Amount
              }
            }
          }
        }`,
      variables: "{}",
    });

    try {
      const response = await this.http.post("/graphql", data);
      return response.data.data.EVM.TokenHolders.map((item) => ({
        address: item.Holder.Address,
        amount: Number(item.Balance.Amount),
      }));
    } catch (err) {
      return [];
    }
  }
}
